import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import projectService from './projectService'
import { filterByThresholdGood,filterByThresholdUnhealthy, filterByThresholdModerate } from '../../aqi/filterThreshholds.js';


const initialState = {
  projects: [],
  project:[],
  projectMeasurements:[],
  filteredProjectMeasurements:[],
  filteredThresholdMeasurements:[],
  publicProject:[],
  lastProject:[],
  projectLength:0,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: '',
}

// Create new goal
export const createProject = createAsyncThunk(
  'projects/create',
  async (projectData, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      return await projectService.createProject(projectData, token)
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      return thunkAPI.rejectWithValue(message)
    }
  }
)

export const getPublicProject = createAsyncThunk(
  'projectpublic',
  async (projectData, thunkAPI) => {
    try {
      return await projectService.getPublicProject(projectData)
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      return thunkAPI.rejectWithValue(message)
    }
  }
)


export const getLastProject = createAsyncThunk(
  'getLastProject',
  async (_, thunkAPI) => {
    try {
      return await projectService.getLastProject()
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      return thunkAPI.rejectWithValue(message)
    }
  }
)

// Get user goals
export const getProjects = createAsyncThunk(
  'projects/getAll',
  async (_, thunkAPI) => {
    try {
      //const token = thunkAPI.getState().auth.user.token
      return await projectService.getProjects()
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      return thunkAPI.rejectWithValue(message)
    }
  }
)

// Get user goals
export const getProject = createAsyncThunk(
  'projects/getProject',
  async (projectData, thunkAPI) => {
    try {
      //const token = thunkAPI.getState().auth.user.token
      return await projectService.getProject(projectData)
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      return thunkAPI.rejectWithValue(message)
    }
  }
)

// Delete user goal
export const deleteProject = createAsyncThunk(
  'projects/delete',
  async (id, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      return await projectService.deleteProject(id, token)
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      return thunkAPI.rejectWithValue(message)
    }
  }
)

export const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    reset: (state) => initialState,
    filterDate: (state,action) => {
    const date = action.payload.date

    state.filteredProjectMeasurements = state.projectMeasurements


    let result = state.filteredProjectMeasurements.filter(object => {
        // Assuming the object has a date property in 'YYYY-MM-DD' format

        let objectDate = new Date(object.date*1000);

        // Check if the year, month and day match
        return objectDate.getFullYear() === date.getFullYear() &&
               objectDate.getMonth() === date.getMonth() &&
               objectDate.getDate() === date.getDate();
    });

    console.log(result.length)
    console.log(state.filteredProjectMeasurements.length)

    state.filteredProjectMeasurements = result


  //  state.publicProject
  },
  filterThresholdGood: (state,action) => {
  const threshold = action.payload

  state.filteredProjectMeasurements = state.projectMeasurements

  state.filteredProjectMeasurements = filterByThresholdGood(state.projectMeasurements,threshold)

//  state.publicProject
},
filterThresholdModerate: (state,action) => {
const threshold = action.payload

state.filteredProjectMeasurements = state.projectMeasurements

state.filteredProjectMeasurements = filterByThresholdModerate(state.projectMeasurements,threshold)

//  state.publicProject
},
filterThresholdUnhealthy: (state,action) => {
const threshold = action.payload

state.filteredProjectMeasurements = state.projectMeasurements

state.filteredProjectMeasurements = filterByThresholdUnhealthy(state.projectMeasurements,threshold)

//  state.publicProject
},
filterThresholdReset: (state,action) => {
const threshold = action.payload

state.filteredProjectMeasurements = state.projectMeasurements


//  state.publicProject
},
  },
  extraReducers: (builder) => {
    builder
      .addCase(createProject.pending, (state) => {
        state.isLoading = true
      })
      .addCase(createProject.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.project.push(action.payload)
      })
      .addCase(createProject.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
      })
      .addCase(getLastProject.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getLastProject.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.lastProject = action.payload
      })
      .addCase(getLastProject.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
      })
      .addCase(getPublicProject.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getPublicProject.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.publicProject = action.payload
        console.log(action.payload)
        state.projectMeasurements = action.payload.deviceProject[0].dataMeasures
        state.filteredProjectMeasurements = action.payload.deviceProject[0].dataMeasures





      })
      .addCase(getPublicProject.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
      })
      .addCase(getProjects.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getProjects.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.projects = action.payload


      })
      .addCase(getProjects.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
      })
      .addCase(getProject.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getProject.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.project = action.payload
      })
      .addCase(getProject.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
      })
      .addCase(deleteProject.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deleteProject.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.projcets = state.projects.filter(
          (project) => project._id !== action.payload.id
        )
      })
      .addCase(deleteProject.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
      })
  },
})

export const { reset,filterDate,filterThresholdGood,filterThresholdUnhealthy,filterThresholdModerate,filterThresholdReset } = projectSlice.actions
export default projectSlice.reducer
